import React, { Fragment, useState, useEffect, useContext } from 'react'
import { useForm } from "react-hook-form";
import { Redirect } from 'react-router-dom'

import AppContext from '../../contexts/AppContext'
import Breadcrumbs from '../Breadcrumbs'
import Header from '../Header'
import Footer from '../Footer'
import { breadcrumbsBy } from '../../services/locations'

import useToastContext from "../../hooks/useToastContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faKey } from '@fortawesome/free-solid-svg-icons'
import { Helmet } from "react-helmet-async";

const ChangePassword = ({ match, history }) => {

    const { authServices, location } = useContext(AppContext)
    const [ loading, setLoading ] = useState(false)
    const [ done, setDone ] = useState(false)

    const { register, handleSubmit, watch, errors, setError, reset } = useForm();

    const addToast = useToastContext()

    const onSubmit = data => {
        setLoading(true)
        authServices.changePassword(data).then(res => {
            setLoading(false)
            addToast({title: 'Success', message: 'Password successfully changed.', type: 'success'})
            reset()
            setDone(true)
        }).catch(res => {
            setLoading(false)
            if(res.data){
                if(res.data.message) addToast({title: 'Error', message: res.data.message, type: 'danger'})
                if(res.data.errors){
                    const keys = Object.keys(res.data.errors)
                    for(var i = 0; i < keys.length; i ++){
                        setError(keys[i], {
                            type: "manual",
                            message: res.data.errors[keys[i]].join('. ')
                        })
                    }
                }
            }
        })
    };

    if(done) return <Redirect to="/account" />

    const title = "Change Password"

    return (
        <Fragment>
            <div>
                <Header history={history} />
                <main className="py-4">
                    <div className="container">
                        <Breadcrumbs list={breadcrumbsBy(location, [{url: '/account', title: 'Dashboard'}, {title}])} />
                        <Helmet><title>{title + ' | ' + process.env.MIX_APP_NAME}</title></Helmet>
                        <h1>{title}</h1>

                        <div className="row">
                            <div className="col-lg-6 col-xl-6">

                                <div className="card">

                                    <form className="card-body" onSubmit={handleSubmit(onSubmit)}>

                                        <div className="mb-3">
                                            <label htmlFor="inputPassword" className="sr-only">Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                name="password"
                                                placeholder="Password"
                                                defaultValue=""
                                                ref={register({ required: true, min: 6 })}
                                            />
                                            {errors.password && <div className="invalid-feedback d-block">{errors.password.message}</div>}
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="inputPassword" className="sr-only">Confirm Password</label>
                                            <input
                                                type="password"
                                                className="form-control"
                                                name="password_confirmation"
                                                placeholder="Confirm Password"
                                                defaultValue=""
                                                ref={register({ required: true, min: 6 })}
                                            />
                                            {errors.password_confirmation && <div className="invalid-feedback d-block">{errors.password_confirmation.message}</div>}
                                        </div>

                                        <div className="d-flex justify-content-end">
                                            <button className="btn btn-primary" type="submit" disabled={loading}>
                                                {loading && <FontAwesomeIcon icon={faSpinner} className="fa-spin" />}
                                                {!loading && <FontAwesomeIcon icon={faKey} />}
                                                <span className="ms-2">Change Password</span>
                                            </button>
                                        </div>

                                    </form>

                                </div>

                            </div>
                        </div>


                    </div>
                </main>
            </div>
            <Footer />
        </Fragment>
    )
}

export default ChangePassword
